export default [
  {
    path: '/elaboracao/:numeroProcesso/documento',
    name: 'incluirDocumento',
    component: () => import(/* webpackChunkName: "elaboracao-documento" */ './documento.vue')
  },
  {
    path: '/elaboracao/:numeroProcesso/documento/:protocolo',
    name: 'editarDocumento',
    component: () => import(/* webpackChunkName: "elaboracao-documento" */ './documento.vue')
  }
]
